var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSystemAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _vm._m(0),
            _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Email")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.email },
                    on: {
                      blur: _vm.handleBlur,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "email", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Username")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.username,
                        expression: "user.username",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.username },
                    on: {
                      blur: _vm.handleBlur,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "username", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Password")]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.password,
                        expression: "user.password",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "password" },
                    domProps: { value: _vm.user.password },
                    on: {
                      blur: _vm.handleBlur,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "password", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Default Administrator")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }